module.exports = __webpack_public_path__ + "img/logo_colored.c9a5264f.svg";